import React, { useState } from "react";

export default function Profile() {
  const [form, setForm] = useState({ name: "Manish Thakkar", email: "mailtoascent@gmail.com", mobile: "9824408923"});

  const handle = (e)=> setForm({...form, [e.target.name]: e.target.value});

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">My Profile</h2>
      <div className="bg-white p-4 rounded shadow">
        <input name="name" value={form.name} onChange={handle} className="w-full p-2 border mb-2" />
        <input name="email" value={form.email} onChange={handle} className="w-full p-2 border mb-2" />
        <input name="mobile" value={form.mobile} onChange={handle} className="w-full p-2 border mb-2" />
        <button className="bg-purple-700 text-white px-4 py-2 rounded">Save Changes</button>
      </div>
    </div>
  );
}
